<div class="pinpad-container" *ngIf="flashPaymentService.controller.canOpenAthPinPad">
  <iframe
    [src]="flashPaymentService.controller.athURL"
    frameborder="0"
    style="width: 100%; height: 600px"
  ></iframe>
</div>
